export const toRGB = RGBString => {
  if (typeof RGBString !== 'string') return {};
  try {
    const c = RGBString.substring(1); // strip #
    const rgb = parseInt(c, 16); // convert rrggbb to decimal
    const r = (rgb >> 16) & 0xff; // extract red
    const g = (rgb >> 8) & 0xff; // extract green
    const b = (rgb >> 0) & 0xff; // extract blue
    return { r, g, b };
  } catch (e) {
    return {};
  }
};

export const getBrightness = RGBString => {
  //http://www.w3.org/TR/AERT#color-contrast
  if (typeof RGBString !== 'string') return 0;
  const rgb = toRGB(RGBString);
  return (rgb?.r * 299 + rgb?.g * 587 + rgb?.b * 114) / 1000;
};

/**
 * Determines if an RGB hex value is dark or not.
 * @param RGBString
 * @returns booleam | null
 */
export const isDark = RGBString => {
  if (typeof RGBString !== 'string') return null;
  return getBrightness(RGBString) < 128;
};
